import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SeoArticle from "../pages/seo-article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/co-to-jest-kakobuy-sheet",
    element: <SeoArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
